import config from '../config'
import fetcher from '../api/fetcher.mjs'

export type VisitorGeoResponse = {
  countryCode: string | null
}

export async function fetchVisitorCountry(): Promise<VisitorGeoResponse> {
  const url = new URL(`${config.REACT_APP_API_URL}/api/geo`)
  if (typeof window !== 'undefined') {
    const country = new URLSearchParams(window.location.search).get('country')
    if (country?.trim()) {
      url.searchParams.set('country', country.trim())
    }
  }
  return fetcher(url.toString(), { method: 'GET' })
}
